import { CoreActions, CoreActionTypes } from '../actions';
import { Driver, DriverName } from '@models/*';

export interface CoreState {
    driver: Driver;
    driverName: DriverName;
    offline: boolean;
    onlineReturning: boolean;
    initComplete: boolean;
    currLang: string;
}

const initState: CoreState = {
    driver: null,
    driverName: null,
    offline: false,
    onlineReturning: false,
    initComplete: false,
    currLang: null
};

export function coreReducer(state = initState, action: CoreActions): CoreState {
    switch (action.type) {
        case CoreActionTypes.STORE_DRIVER: {
            return {
                ...state,
                driver: action.payload
            };
        }

        case CoreActionTypes.SET_OFFLINE_STATUS: {
            return {
                ...state,
                offline: action.payload,
                onlineReturning: false
            };
        }

        case CoreActionTypes.SET_ONLINE_RETURNING: {
            return {
                ...state,
                offline: true,
                onlineReturning: true
            };
        }

        case CoreActionTypes.BACK_ONLINE: {
            return {
                ...state,
                offline: false,
                onlineReturning: false
            };
        }

        case CoreActionTypes.COMPLETE_APP_INIT: {
            return {
                ...state,
                initComplete: true
            };
        }

        case CoreActionTypes.SAVE_DRIVER_NAME: {
            return {
                ...state,
                driverName: action.payload
            };
        }

        case CoreActionTypes.SET_LANG: {
            return {
                ...state,
                currLang: action.payload.lang
            };
        }
    }

    return state;
}
